import { EAuthenticateError, EAuthenticateStatus } from '../../types/authentication';
export function hasCodeErrorSelector(state) {
  var _state$authentication = state.authentication.authenticate,
    status = _state$authentication.status,
    errorType = _state$authentication.errorType;
  return status === EAuthenticateStatus.Failed && errorType !== EAuthenticateError.TwoFactorRequired;
}
export function codeErrorSelector(state) {
  if (!hasCodeErrorSelector(state)) {
    return undefined;
  }
  return state.authentication.authenticate.error;
}
export function isSubmittingSelector(state) {
  var authStatus = state.authentication.authenticate.status;
  return authStatus === EAuthenticateStatus.Loading;
}